import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from '../../store/index';
import { withStyles } from '@material-ui/core/styles';
import { Button, FormControl, Grid, Input, InputLabel, Paper, Select, TextField, Typography } from '@material-ui/core';
import classnames from 'classnames';
import SimpleTable from 'components/SimpleTable';
import ExpandableCell from 'components/SimpleTable/ExpandableCell';
import svc from 'svc';
import { memoize } from "lodash";



const styles = theme => ({
	gridRoot: {
		flexGrow: 1,
		width: '100%',
		margin: 16,
	},
	searchButton: {
		marginRight: 16,
	},
	searchTable: {
		minHeight: 600,
		marginTop: 30,
		marginRight: 32,
	},
	formField: {
		width: '100%',
	},
});

const searchCols = [
	{ name: 'DocNum', title: 'Document Number' },
	{ name: 'Type', title: 'Document Type' },
	{ name: 'CardCode', title: 'BP Code' },
	{ name: 'CardName', title: 'BP Name' },
	{ name: 'SalesPerson', title: 'Sales Employee' },
	{ name: 'DocDate', title: 'Document Date' },
	{ name: 'DocStatus', title: 'Status' },
	{ name: 'Canceled', title: 'Canceled?' },
	{ name: 'Remarks', title: 'Remarks' },
];



class DocumentSearch extends React.PureComponent {
	state = {
		values: {
			DocNum: '',
			CardCode: '',
			CardName: '',
			FromDate: '',
			ToDate: '',
			DocStatus: '',
			Canceled: '',
			SlpCode: '',
		},
		searching: false,
		rows: [],
		redirect: '',
	};


	componentDidMount = () => {
		if ( this.props.appData.UserSlpCode ) {
			let slp = Number(this.props.appData.UserSlpCode);
			if ( slp !== -1 ) this.setState({ values: { ...this.state.values, SlpCode: slp } });
		}
	};


	updateSearchVal = memoize(key => event => {
		this.setState({
			values: {
				...this.state.values,
				[ key ]: event.target.value,
			},
		});
	});


	updateDate = memoize(key => event => {
		let update = { ...this.state.values, [ key ]: event.target.value };

		if ( key === 'FromDate' && !update.ToDate ) {
			update.ToDate = event.target.value;
		}

		if ( key === 'ToDate' && !update.FromDate ) {
			update.FromDate = event.target.value;
		}

		this.setState({
			values: update,
		});
	});


	handleSearch = ( e ) => {
		e.preventDefault();
		this.setState({ searching: true, rows: [] });

		svc.send('salesorder', { method: 'search', ...this.state.values }).then(res => {
			this.setState({
				searching: false,
				rows: res.payload.data,
			});
		});
	};


	onRowSelect = ( sel ) => {
		if ( !sel.length ) {
			return false;
		}

		let type;
		let row = this.state.rows[ sel[ 0 ] ];

		if ( row.isDraft === 'Y' && row.isQuote === 'Y' ) {
			type = 'salesquotedraft';
		} else if ( row.isDraft === 'N' && row.isQuote === 'Y' ) {
			type = 'salesquote';
		} else if ( row.isDraft === 'Y' && row.isQuote === 'N' ) {
			type = 'salesorderdraft';
		} else if ( row.isDraft === 'N' && row.isQuote === 'N' ) {
			type = 'salesorder';
		} else {
			console.log('Could not determine type');
			return false;
		}

		this.setState({ redirect: `/businesspartners/view/${row.CardCode}/${type}/${row.DocEntry}` });
	};


	render() {
		const classes = this.props.classes;
		const tableClass = classnames(classes.searchTable, this.state.searching && 'automat-loading');
		let values = this.state.values;

		return (
			<div>
				<form onSubmit={this.handleSearch} className={classes.formField}>
					<Grid container spacing={16} className={classes.gridRoot}>

						<Grid item xs={12}>
							<Typography variant="h6">Order/Quote Search</Typography>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="number"
								value={values.DocNum}
								label="Document Number"
								onChange={this.updateSearchVal('DocNum')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.CardCode}
								label="BP Code"
								onChange={this.updateSearchVal('CardCode')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={3} xl={2}>
							<TextField
								type="text"
								value={values.CardName}
								label="BP Name"
								onChange={this.updateSearchVal('CardName')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>Sales Employee</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('SlpCode')}
									value={values.SlpCode}
									className={classes.formField}
								>
									<option value="" />
									{this.props.appData.SalesPersons.map(slp => {
										return <option key={slp.val} value={slp.val}>{slp.disp}</option>;
									})}
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="date"
								value={values.FromDate}
								label="Date Range - Start"
								onChange={this.updateSearchVal('FromDate')}
								onBlur={this.updateDate('FromDate')}
								className={classes.formField}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="date"
								value={values.ToDate}
								label="Date Range - End"
								onChange={this.updateSearchVal('ToDate')}
								onBlur={this.updateDate('ToDate')}
								className={classes.formField}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>Status</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('DocStatus')}
									value={values.DocStatus}
									className={classes.formField}
								>
									<option value="" />
									<option value="O">Open</option>
									<option value="C">Closed</option>
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>Canceled?</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('Canceled')}
									value={values.Canceled}
									className={classes.formField}
								>
									<option value="" />
									<option value="N">No</option>
									<option value="Y">Yes</option>
								</Select>
							</FormControl>
						</Grid>

						<Grid item>
							<Button
								variant="contained"
								color="primary"
								className={classes.searchButton}
								onClick={this.handleSearch}
								disabled={this.state.searching}
								type={'submit'}
							>
								Search
							</Button>
						</Grid>

						<Grid item xs={12}>
							<Paper className={tableClass}>
								<SimpleTable
									columns={searchCols}
									rows={this.state.rows}
									onRowSelect={this.onRowSelect}
									defaultPageSize={15}
									cellComponent={ExpandableCell}
								/>
							</Paper>
						</Grid>

					</Grid>

					{
						this.state.redirect
						&& window.location.pathname !== this.state.redirect
						&& <Redirect to={this.state.redirect} push />
					}

				</form>
			</div>
		);
	}
}



const mapStateToProps = state => {
	return {
		appData: state.appData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setTitle: ( title ) => {
			dispatch(actions.layout.setTitle(title));
		},
	}
};

DocumentSearch = withStyles(styles)(DocumentSearch);
export default connect(mapStateToProps, mapDispatchToProps)(DocumentSearch);